(ns ui.mcp.register
  "UI register of the MCP slice: the Storrito MCP page under /ui/mcp.
   Nothing links the route, the sidebar entry is the launch PR."
  (:require [ui.mcp.page :as page]))

(def register
  [page/page])
